import { render } from "./elecBoardPackage.vue?vue&type=template&id=5a54e5ae"
import script from "./elecBoardPackage.vue?vue&type=script&lang=js"
export * from "./elecBoardPackage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__